/**
 * CRO-WEB-176 Personalisation Subheader on Preference Selection Experimentation
 *
 * Gets the experiment variant from PostHog feature flag.
 * This experiment tests different subheader text on preference selection steps.
 */

import posthog from "posthog-js";
import { useFeatureFlagVariantKey } from "posthog-js/react";
import { useExperimentOverride } from "../useExperimentOverride";

/**
 * Hook to get the CRO-WEB-176 experiment variant
 * Returns the variant string or null if not assigned
 * Supports development overrides via localStorage
 */
export const useCroWeb176Variant = () => {
  const posthogVariant = useFeatureFlagVariantKey("cro-web-176");
  const { effectiveVariant, isInitialized } = useExperimentOverride(
    "cro-web-176",
    posthogVariant
  );

  return { variant: effectiveVariant, isInitialized };
};

/**
 * Get variant from PostHog feature flag (client-side only)
 * Used for experiment tracking configuration
 */
export const getCroWeb176Variant = (): string | null => {
  if (typeof window === "undefined") return null;

  // Check for experiment override first
  const experimentOverride = localStorage.getItem("dev_variant_cro-web-176");
  if (experimentOverride) {
    return experimentOverride;
  }

  try {
    const variant = posthog.getFeatureFlag("cro-web-176");
    return typeof variant === "string" ? variant : null;
  } catch (error) {
    return null;
  }
};
